import { __extends } from "tslib";
/**
* WebAnalyticsPlugin.ts
* @author Ram Thiru (ramthi) and Hector Hernandez (hectorh)
* @copyright Microsoft 2018
* File containing the interfaces for WebAnalytics SDK.
*/
import dynamicProto from "@microsoft/dynamicproto-js";
import { BaseTelemetryPlugin, createProcessTelemetryContext, onConfigChange } from "@microsoft/applicationinsights-core-js";
import { objDeepFreeze } from "@nevware21/ts-utils";
import { Ix } from "./Ix";
var defaultIdSyncConfig = objDeepFreeze({
    adobe: false,
    google: false
});
var IdSyncPlugin = /** @class */ (function (_super) {
    __extends(IdSyncPlugin, _super);
    function IdSyncPlugin() {
        var _this = _super.call(this) || this;
        _this.identifier = "IdSyncPlugin";
        _this.version = '4.4.1';
        var _ix;
        var addResponseHandler;
        var _idSyncConfig;
        var _setIx = false;
        var unloadhook;
        dynamicProto(IdSyncPlugin, _this, function (_self, _base) {
            _self.initialize = function (coreConfig, core, extensions) {
                // Make sure we have a config definition for this identifier
                var identifier = _this.identifier;
                // Check in channels
                var postChannel = core.getPlugin("PostChannel");
                _self._addHook(onConfigChange(coreConfig, function (details) {
                    var coreConfig = details.cfg;
                    var ctx = createProcessTelemetryContext(null, coreConfig, core);
                    _idSyncConfig = ctx.getExtCfg(identifier, defaultIdSyncConfig);
                    if (postChannel) {
                        if (_setIx) { // already set before
                            // remove previous response handler
                            unloadhook.rm();
                            _setIx = false;
                        }
                        if (!_setIx) {
                            _ix = new Ix(_idSyncConfig, core);
                            _setIx = true;
                            addResponseHandler = function (response) { _ix.idSync(response); };
                            unloadhook = postChannel.plugin.addResponseHandler(addResponseHandler);
                        }
                    }
                    // Special internal method to allow the unit tests to hook embedded objects
                    _self["_getDbgPlgTargets"] = function () {
                        return [_idSyncConfig, _ix];
                    };
                }));
            };
            _self.processTelemetry = function (evt, itemCtx) {
                _self.processNext(evt, itemCtx);
            };
            _self._doTeardown = function (unloadCtx, unloadState) {
                _ix = null;
            };
        });
        return _this;
    }
    /**
     * Starts the WebAnalytics plugin
     * @param config The core configuration.
    */
    IdSyncPlugin.prototype.initialize = function (coreConfig, core, extensions) {
        // @DynamicProtoStub - DO NOT add any code as this will be removed during packaging
    };
    /**
     * Process a given event.
     * Hydrate with appropriate PartB and PartC data
     * @param evt - The event to be hydrated.
     * @param itemCtx - This is the context for the current request, ITelemetryPlugin instances
     * can optionally use this to access the current core instance or define / pass additional information
     * to later plugins (vs appending items to the telemetry item)
     */
    IdSyncPlugin.prototype.processTelemetry = function (evt, itemCtx) {
        // @DynamicProtoStub - DO NOT add any code as this will be removed during packaging
    };
    return IdSyncPlugin;
}(BaseTelemetryPlugin));
export { IdSyncPlugin };
//# sourceMappingURL=IdSyncPlugin.js.map